import ic_add_column from "../assets/Icons/ic_add_column.png";
import ic_add_white1 from "../assets/Icons/ic_add_white.png";
import ic_add from "../assets/Icons/ic_add.png";
import ic_apple from "../assets/Icons/ic_apple.png";
import ic_arrow_down from "../assets/Icons/ic_arrow_down.png";
import ic_arrow_down2 from "../assets/Icons/ic_arrow_down2.png";
import ic_arrow_left from "../assets/Icons/ic_arrow_left.png";
import ic_arrow_right from "../assets/Icons/ic_arrow_right.png";
import ic_arrow_right2 from "../assets/Icons/ic_arrow_right2.png";
import ic_arrow_up from "../assets/Icons/ic_arrow_up.png";
import ic_arrow_up2 from "../assets/Icons/ic_arrow_up2.png";
import ic_attachment from "../assets/Icons/ic_attachment.png";
import ic_blank from "../assets/Icons/ic_blank.png";
import ic_books from "../assets/Icons/ic_books.png";
import ic_calendar_ from "../assets/Icons/ic_calendar_.png";
import ic_calendar from "../assets/Icons/ic_calendar.png";
import ic_cards from "../assets/Icons/ic_cards.png";
import ic_cart from "../assets/Icons/ic_cart.png";
import ic_check_mark_white from "../assets/Icons/ic_check_mark_white.png";
import ic_check_mark from "../assets/Icons/ic_check_mark.png";
import ic_checkbox_checked from "../assets/Icons/ic_checkbox_checked.png";
import ic_checkbox_empty from "../assets/Icons/ic_checkbox_empty.png";
import ic_close_ from "../assets/Icons/ic_close_.png";
import ic_close_2 from "../assets/Icons/ic_close_2.png";
import ic_close from "../assets/Icons/ic_close.png";
import ic_comment from "../assets/Icons/ic_comment.png";
import ic_company from "../assets/Icons/ic_company.png";
import ic_copy from "../assets/Icons/ic_copy.png";
import ic_country from "../assets/Icons/ic_country.png";
import ic_coupon from "../assets/Icons/ic_coupon.png";
import ic_currency from "../assets/Icons/ic_currency.png";
import ic_dashboard from "../assets/Icons/ic_dashboard.png";
import ic_delete from "../assets/Icons/ic_delete.png";
import ic_delivery from "../assets/Icons/ic_delivery.png";
import ic_document from "../assets/Icons/ic_document.png";
import ic_download from "../assets/Icons/ic_download.png";
import ic_edit from "../assets/Icons/ic_edit.png";
import ic_email from "../assets/Icons/ic_email.png";
import ic_export from "../assets/Icons/ic_export.png";
import ic_facebook from "../assets/Icons/ic_facebook.png";
import ic_facebook2 from "../assets/Icons/ic_facebook2.png";
import ic_filter from "../assets/Icons/ic_filter.png";
import ic_google from "../assets/Icons/ic_google.png";
import ic_help from "../assets/Icons/ic_help.png";
import ic_home from "../assets/Icons/ic_home.png";
import ic_import from "../assets/Icons/ic_import.png";
import ic_info from "../assets/Icons/ic_info.png";
import ic_instagram from "../assets/Icons/ic_instagram.png";
import ic_key_2 from "../assets/Icons/ic_key_2.png";
import ic_key from "../assets/Icons/ic_key.png";
import ic_learn from "../assets/Icons/ic_learn.png";
import ic_like from "../assets/Icons/ic_like.png";
import ic_linkedin from "../assets/Icons/ic_linkedin.png";
import ic_loading from "../assets/Icons/ic_loading.png";
import ic_location from "../assets/Icons/ic_location.png";
import ic_lock from "../assets/Icons/ic_lock.png";
import ic_logout from "../assets/Icons/ic_logout.png";
import ic_mail from "../assets/Icons/ic_mail.png";
import ic_menu from "../assets/Icons/ic_menu.png";
import ic_more from "../assets/Icons/ic_more.png";
import ic_notification from "../assets/Icons/ic_notification.png";
import ic_paint from "../assets/Icons/ic_paint.png";
import ic_password from "../assets/Icons/ic_password.png";
import ic_people from "../assets/Icons/ic_people.png";
import ic_person from "../assets/Icons/ic_person.png";
import ic_phone from "../assets/Icons/ic_phone.png";
import ic_plasma from "../assets/Icons/ic_plasma.png";
import ic_printer from "../assets/Icons/ic_printer.png";
import ic_product from "../assets/Icons/ic_product.png";
import ic_profile from "../assets/Icons/ic_profile.png";
import ic_quantity from "../assets/Icons/ic_quantity.png";
import ic_recent from "../assets/Icons/ic_recent.png";
import ic_repeat from "../assets/Icons/ic_repeat.png";
import ic_reports from "../assets/Icons/ic_reports.png";
import ic_resource from "../assets/Icons/ic_resource.png";
import ic_role from "../assets/Icons/ic_role.png";
import ic_sales from "../assets/Icons/ic_sales.png";
import ic_save from "../assets/Icons/ic_save.png";
import ic_search from "../assets/Icons/ic_search.png";
import ic_settings from "../assets/Icons/ic_settings.png";
import ic_share_ from "../assets/Icons/ic_share_.png";
import ic_share from "../assets/Icons/ic_share.png";
import ic_shopping from "../assets/Icons/ic_shopping.png";
import ic_sort from "../assets/Icons/ic_sort.png";
import ic_support from "../assets/Icons/ic_support.png";
import ic_tax from "../assets/Icons/ic_tax.png";
import ic_text from "../assets/Icons/ic_text.png";
import ic_textfield from "../assets/Icons/ic_textfield.png";
import ic_twitter from "../assets/Icons/ic_twitter.png";
import ic_user_2 from "../assets/Icons/ic_user_2.png";
import ic_user from "../assets/Icons/ic_user.png";
import ic_vaccine from "../assets/Icons/ic_vaccine.png";
import ic_volunteer from "../assets/Icons/ic_volunteer.png";
import ic_warning_red from "../assets/Icons/ic_warning_red.png";
import ic_warning from "../assets/Icons/ic_warning.png";

import ic_add_white from "../assets/Icons/white/ic_add_white.png";
import ic_cards_white from "../assets/Icons/white/ic_cards.png";
import ic_cart_white from "../assets/Icons/white/ic_cart.png";
import ic_check_mark_white1 from "../assets/Icons/white/ic_check_mark.png";
import ic_comment_white from "../assets/Icons/white/ic_comment.png";
import ic_company_white from "../assets/Icons/white/ic_company.png";
import ic_coupon_white from "../assets/Icons/white/ic_coupon.png";
import ic_dashboard_white from "../assets/Icons/white/ic_dashboard.png";
import ic_delete_white from "../assets/Icons/white/ic_delete.png";
import ic_help_white from "../assets/Icons/white/ic_help.png";
import ic_home_white from "../assets/Icons/white/ic_home.png";
import ic_key_2_white from "../assets/Icons/white/ic_key_2.png";
import ic_key_white from "../assets/Icons/white/ic_key.png";
import ic_learn_white from "../assets/Icons/white/ic_learn.png";
import ic_lock_white from "../assets/Icons/white/ic_lock.png";
import ic_logout_white from "../assets/Icons/white/ic_logout.png";
import ic_notification_white from "../assets/Icons/white/ic_notification.png";
import ic_plasma_white from "../assets/Icons/white/ic_plasma.png";
import ic_product_white from "../assets/Icons/white/ic_product.png";
import ic_repeat_white from "../assets/Icons/white/ic_repeat.png";
import ic_reports_white from "../assets/Icons/white/ic_reports.png";
import ic_resource_white from "../assets/Icons/white/ic_resource.png";
import ic_role_white from "../assets/Icons/white/ic_role.png";
import ic_settings_white from "../assets/Icons/white/ic_settings.png";
import ic_telegram_white from "../assets/Icons/white/ic_telegram.png";
import ic_user_white from "../assets/Icons/white/ic_user.png";
import ic_vaccine_white from "../assets/Icons/white/ic_vaccine.png";
import ic_volunteer_white from "../assets/Icons/white/ic_volunteer.png";
import ic_whatsapp_white from "../assets/Icons/white/ic_whatsapp.png";

import ic_data_type_ic_checkbox from "../assets/Icons/data_type/ic_checkbox.png";
import ic_data_type_ic_date from "../assets/Icons/data_type/ic_date.png";
import ic_data_type_ic_email from "../assets/Icons/data_type/ic_email.png";
import ic_data_type_ic_multi_select from "../assets/Icons/data_type/ic_multi_select.png";
import ic_data_type_ic_number from "../assets/Icons/data_type/ic_number.png";
import ic_data_type_ic_select from "../assets/Icons/data_type/ic_select.png";
import ic_data_type_ic_text from "../assets/Icons/data_type/ic_text.png";
import ic_data_type_ic_url from "../assets/Icons/data_type/ic_url.png";

export const DKIcons = {
  ic_add_column: ic_add_column,
  ic_add_white: ic_add_white1,
  ic_add: ic_add,
  ic_apple: ic_apple,
  ic_arrow_down: ic_arrow_down,
  ic_arrow_down2: ic_arrow_down2,
  ic_arrow_left: ic_arrow_left,
  ic_arrow_right: ic_arrow_right,
  ic_arrow_right2: ic_arrow_right2,
  ic_arrow_up: ic_arrow_up,
  ic_arrow_up2: ic_arrow_up2,
  ic_attachment: ic_attachment,
  ic_blank: ic_blank,
  ic_books: ic_books,
  ic_calendar_: ic_calendar_,
  ic_calendar: ic_calendar,
  ic_cards: ic_cards,
  ic_cart: ic_cart,
  ic_check_mark_white: ic_check_mark_white,
  ic_check_mark: ic_check_mark,
  ic_checkbox_checked: ic_checkbox_checked,
  ic_checkbox_empty: ic_checkbox_empty,
  ic_close_: ic_close_,
  ic_close_2: ic_close_2,
  ic_close: ic_close,
  ic_comment: ic_comment,
  ic_company: ic_company,
  ic_copy: ic_copy,
  ic_country: ic_country,
  ic_coupon: ic_coupon,
  ic_currency: ic_currency,
  ic_dashboard: ic_dashboard,
  ic_delete: ic_delete,
  ic_delivery: ic_delivery,
  ic_document: ic_document,
  ic_download: ic_download,
  ic_edit: ic_edit,
  ic_email: ic_email,
  ic_export: ic_export,
  ic_facebook: ic_facebook,
  ic_facebook2: ic_facebook2,
  ic_filter: ic_filter,
  ic_google: ic_google,
  ic_help: ic_help,
  ic_home: ic_home,
  ic_import: ic_import,
  ic_info: ic_info,
  ic_instagram: ic_instagram,
  ic_key_2: ic_key_2,
  ic_key: ic_key,
  ic_learn: ic_learn,
  ic_like: ic_like,
  ic_linkedin: ic_linkedin,
  ic_loading: ic_loading,
  ic_location: ic_location,
  ic_lock: ic_lock,
  ic_logout: ic_logout,
  ic_mail: ic_mail,
  ic_menu: ic_menu,
  ic_more: ic_more,
  ic_notification: ic_notification,
  ic_paint: ic_paint,
  ic_password: ic_password,
  ic_people: ic_people,
  ic_person: ic_person,
  ic_phone: ic_phone,
  ic_plasma: ic_plasma,
  ic_printer: ic_printer,
  ic_product: ic_product,
  ic_profile: ic_profile,
  ic_quantity: ic_quantity,
  ic_recent: ic_recent,
  ic_repeat: ic_repeat,
  ic_reports: ic_reports,
  ic_resource: ic_resource,
  ic_role: ic_role,
  ic_sales: ic_sales,
  ic_save: ic_save,
  ic_search: ic_search,
  ic_settings: ic_settings,
  ic_share_: ic_share_,
  ic_share: ic_share,
  ic_shopping: ic_shopping,
  ic_sort: ic_sort,
  ic_support: ic_support,
  ic_tax: ic_tax,
  ic_text: ic_text,
  ic_textfield: ic_textfield,
  ic_twitter: ic_twitter,
  ic_user_2: ic_user_2,
  ic_user: ic_user,
  ic_vaccine: ic_vaccine,
  ic_volunteer: ic_volunteer,
  ic_warning_red: ic_warning_red,
  ic_warning: ic_warning,
  data_type: {
    ic_checkbox: ic_data_type_ic_checkbox,
    ic_date: ic_data_type_ic_date,
    ic_email: ic_data_type_ic_email,
    ic_multi_select: ic_data_type_ic_multi_select,
    ic_number: ic_data_type_ic_number,
    ic_select: ic_data_type_ic_select,
    ic_text: ic_data_type_ic_text,
    ic_url: ic_data_type_ic_url,
  },
  white: {
    ic_add: ic_add_white,
    ic_cards: ic_cards_white,
    ic_cart: ic_cart_white,
    ic_check_mark: ic_check_mark_white1,
    ic_comment: ic_comment_white,
    ic_company: ic_company_white,
    ic_coupon: ic_coupon_white,
    ic_dashboard: ic_dashboard_white,
    ic_delete: ic_delete_white,
    ic_help: ic_help_white,
    ic_home: ic_home_white,
    ic_key_2: ic_key_2_white,
    ic_key: ic_key_white,
    ic_learn: ic_learn_white,
    ic_lock: ic_lock_white,
    ic_logout: ic_logout_white,
    ic_notification: ic_notification_white,
    ic_plasma: ic_plasma_white,
    ic_product: ic_product_white,
    ic_repeat: ic_repeat_white,
    ic_reports: ic_reports_white,
    ic_resource: ic_resource_white,
    ic_role: ic_role_white,
    ic_settings: ic_settings_white,
    ic_telegram: ic_telegram_white,
    ic_user: ic_user_white,
    ic_vaccine: ic_vaccine_white,
    ic_volunteer: ic_volunteer_white,
    ic_whatsapp: ic_whatsapp_white,
  },
};
